module.exports = __webpack_public_path__ + "static/media/26UNRWA8.0a150e0e.jpg";